import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'formatString'})
export class FormatStringPipe implements PipeTransform {

    constructor() { }

    transform(value: string, args: any): string {
        switch(args) {
            case 'policyAPI': return this.formatPolicyAPI(value);
            default: return value;
        }
    }

    formatPolicyAPI(value: string): string {
        let chunks = value.split(',');
        return chunks[1] + ' ' + chunks[0];
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/pipes/format-string.pipe.ts